var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0495 8.70139L17.2328 12.1847C16.5328 15.1931 15.1495 16.4097 12.5495 16.1597C12.1328 16.1264 11.6828 16.0514 11.1995 15.9347L9.7995 15.6014C6.3245 14.7764 5.2495 13.0597 6.06617 9.57639L6.88283 6.08472C7.0495 5.37639 7.2495 4.75972 7.4995 4.25139C8.4745 2.23472 10.1328 1.69306 12.9162 2.35139L14.3078 2.67639C17.7995 3.49306 18.8662 5.21806 18.0495 8.70139Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5493 16.1583C12.0326 16.5083 11.3826 16.8 10.591 17.0583L9.27431 17.4917C5.96597 18.5583 4.22431 17.6667 3.14931 14.3583L2.08264 11.0667C1.01597 7.75833 1.89931 6.00833 5.20764 4.94167L6.52431 4.50833C6.86597 4.4 7.19097 4.30833 7.49931 4.25C7.24931 4.75833 7.04931 5.375 6.88264 6.08333L6.06597 9.575C5.24931 13.0583 6.32431 14.775 9.79931 15.6L11.1993 15.9333C11.6826 16.05 12.1326 16.125 12.5493 16.1583Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 7.10938L14.5749 8.13438",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7168 10.332L12.1335 10.9487",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentManagement);
export default __webpack_public_path__ + "static/media/document_management.47d9e506d5fa82417934b0c941b1a7b1.svg";
export { ForwardRef as ReactComponent };